import { createFileRoute } from '@tanstack/react-router'
import { AdminAuthGate } from '../components/auth/admin-auth-gate'
import { AdminQuotes } from '../components/pages/AdminQuotes'

export const Route = createFileRoute('/admin_/quotes')({
  validateSearch: (search: Record<string, unknown>) => ({
    enquiry: typeof search.enquiry === 'string' ? search.enquiry : undefined,
  }),
  component: AdminQuotesComponent,
  head: () => ({
    title: 'Enquiries | AUTOGLOW Detailing Admin',
    meta: [
      { title: 'Enquiries | AUTOGLOW Detailing Admin' },
      { name: 'robots', content: 'noindex,nofollow' },
    ],
  }),
})

function AdminQuotesComponent() {
  const search = Route.useSearch()
  return (
    <AdminAuthGate>
      <AdminQuotes enquiryReference={search.enquiry} />
    </AdminAuthGate>
  )
}
